import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const InfoOutlineIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' role='img' viewBox='0 0 16 16' aria-label='Info' {...props} ref={ref}>
        <path d='M7.333 6h1.334V4.667H7.333V6ZM8 13.333A5.34 5.34 0 0 1 2.667 8 5.34 5.34 0 0 1 8 2.667 5.34 5.34 0 0 1 13.333 8 5.34 5.34 0 0 1 8 13.333Zm0-12a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm-.667 10h1.334v-4H7.333v4Z' />
    </svg>
));
